"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("@aperza/fabric");
var CreateStamp_1 = require("./stamps/CreateStamp");
exports.scaleObjects = function (_a) {
    var fabricCanvas = _a.fabricCanvas, xScale = _a.xScale, yScale = _a.yScale, renderAll = _a.renderAll;
    fabricCanvas.getObjects().forEach(function (obj) {
        obj.scaleX = xScale * obj.scaleX;
        obj.scaleY = yScale * obj.scaleY;
        obj.top = yScale * obj.top;
        obj.left = xScale * obj.left;
        obj.setCoords();
    });
    if (renderAll) {
        fabricCanvas.renderAll();
    }
};
exports.rotateObjects = function (_a) {
    var fabricCanvas = _a.fabricCanvas, rotate = _a.rotate, originalWidth = _a.originalWidth, originalHeight = _a.originalHeight, renderAll = _a.renderAll;
    var _b, _c, _d;
    // this fixes a bug in fabric where the objects in a group are not updated
    (_d = (_c = (_b = fabricCanvas.getActiveObjects()) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.group) === null || _d === void 0 ? void 0 : _d.destroy();
    var rotateObjectsInner = function (rotationPoint, modifiedRotate) {
        var radians = fabric_1.fabric.util.degreesToRadians(modifiedRotate);
        fabricCanvas.getObjects().forEach(function (obj) {
            var objectOrigin = new fabric_1.fabric.Point(obj.left, obj.top);
            var newLocation = fabric_1.fabric.util.rotatePoint(objectOrigin, rotationPoint, radians);
            obj.top = newLocation.y;
            obj.left = newLocation.x;
            obj.angle += modifiedRotate;
            obj.setCoords();
        });
    };
    switch (rotate) {
        case 90:
            rotateObjectsInner(new fabric_1.fabric.Point(originalHeight / 2, originalHeight / 2), 90);
            break;
        case 180:
            rotateObjectsInner(new fabric_1.fabric.Point(originalWidth / 2, originalHeight / 2), 180);
            break;
        case 270:
            rotateObjectsInner(new fabric_1.fabric.Point(originalWidth / 2, originalHeight / 2), 180);
            rotateObjectsInner(new fabric_1.fabric.Point(originalHeight / 2, originalHeight / 2), 90);
            break;
        case -90:
            rotateObjectsInner(new fabric_1.fabric.Point(originalHeight / 2, originalHeight / 2), -90);
            break;
        case -180:
            rotateObjectsInner(new fabric_1.fabric.Point(originalWidth / 2, originalHeight / 2), -180);
            break;
        case -270:
            rotateObjectsInner(new fabric_1.fabric.Point(originalHeight / 2, originalHeight / 2), -90);
            rotateObjectsInner(new fabric_1.fabric.Point(originalWidth / 2, originalHeight / 2), -180);
            break;
        default:
            break;
    }
    if (renderAll) {
        fabricCanvas.renderAll();
    }
};
/**
 * Rotate objects without the need to rotate back the objects first..
 * @param fabricCanvas
 * @param prevRotationAngle
 * @param rotationAngle
 * @param prevWidth
 * @param prevHeight
 * @param width
 * @param height
 * @param renderAll
 */
exports.rotateObjectsByAngleDelta = function (_a) {
    var fabricCanvas = _a.fabricCanvas, prevRotationAngle = _a.prevRotationAngle, rotationAngle = _a.rotationAngle, prevWidth = _a.prevWidth, prevHeight = _a.prevHeight, width = _a.width, height = _a.height, renderAll = _a.renderAll;
    var _b, _c, _d;
    if (fabricCanvas instanceof fabric_1.fabric.Canvas) {
        // this fixes a bug in fabric where the objects in a group are not updated
        (_d = (_c = (_b = fabricCanvas.getActiveObjects()) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.group) === null || _d === void 0 ? void 0 : _d.destroy();
    }
    var angleDelta = rotationAngle - prevRotationAngle;
    var radians = fabric_1.fabric.util.degreesToRadians(angleDelta);
    fabricCanvas.getObjects().forEach(function (obj) {
        if (obj) {
            var objectOrigin = new fabric_1.fabric.Point(obj.left || 0, obj.top || 0);
            var newLocation = fabric_1.fabric.util.rotatePoint(objectOrigin, new fabric_1.fabric.Point(0, 0), radians);
            var translateX = 0;
            var translateY = 0;
            if (angleDelta === 90 || angleDelta === -270) {
                translateX = prevHeight;
            }
            else if (angleDelta === -90 || angleDelta === 270) {
                translateY = prevWidth;
            }
            else if (angleDelta === 180 || angleDelta === -180) {
                translateX = prevWidth;
                translateY = prevHeight;
            }
            obj.top = newLocation.y + translateY;
            obj.left = newLocation.x + translateX;
            // eslint-disable-next-line no-param-reassign
            // @ts-ignore
            obj.angle += angleDelta;
            obj.setCoords();
        }
    });
    var prevRotatedWidth = prevWidth;
    var prevRotatedHeight = prevHeight;
    if (angleDelta === 90 || angleDelta === -270 || angleDelta === -90 || angleDelta === 270) {
        prevRotatedWidth = prevHeight;
        prevRotatedHeight = prevWidth;
    }
    var rotatedWidth = width;
    var rotatedHeight = height;
    exports.scaleObjects({
        fabricCanvas: fabricCanvas,
        xScale: rotatedWidth / prevRotatedWidth,
        yScale: rotatedHeight / prevRotatedHeight,
        renderAll: renderAll,
    });
};
exports.setControlsVisibility = function (fabricCanvas) {
    fabricCanvas.getObjects().forEach(function (obj) {
        var _a, _b, _c, _d, _e;
        if (obj.type === 'textbox') {
            obj.setControlsVisibility({
                mt: false,
                mb: false,
            });
            //@ts-ignore
        }
        else if (((_a = obj._objects) === null || _a === void 0 ? void 0 : _a.length) === 6) {
            //datestamp
            obj.setControlsVisibility({
                ml: false,
                mt: false,
                mr: false,
                mb: false,
            });
            //@ts-ignore
        }
        else if (((_b = obj._objects) === null || _b === void 0 ? void 0 : _b.length) === 2) {
            // parallel lines, diagonal parallel lines, arrow
            // do nothing, default controls
            //@ts-ignore
        }
        else if (((_c = obj.path) === null || _c === void 0 ? void 0 : _c.length) === 6) {
            // circle
            // do nothing, default controls
            //@ts-ignore
        }
        else if (((_d = obj.path) === null || _d === void 0 ? void 0 : _d.length) === 120) {
            //onchu
            obj.setControlsVisibility({
                ml: false,
                mt: false,
                mr: false,
                mb: false,
            });
            //@ts-ignore
        }
        else if (((_e = obj.path) === null || _e === void 0 ? void 0 : _e.length) === 99) {
            //sama
            obj.setControlsVisibility({
                ml: false,
                mt: false,
                mr: false,
                mb: false,
            });
        }
    });
};
exports.keepObjectVisible = function (activeObject) {
    var coords = activeObject.calcCoords(true);
    var leftMost = Math.min(coords.bl.x, coords.br.x, coords.tl.x, coords.tr.x);
    var rightMost = Math.max(coords.bl.x, coords.br.x, coords.tl.x, coords.tr.x);
    var topMost = Math.min(coords.bl.y, coords.br.y, coords.tl.y, coords.tr.y);
    var bottomMost = Math.max(coords.bl.y, coords.br.y, coords.tl.y, coords.tr.y);
    var _a = activeObject.canvas, width = _a.width, height = _a.height;
    var modified = false;
    if (leftMost < 0) {
        activeObject.set('left', coords.tl.x + -leftMost);
        modified = true;
    }
    if (rightMost > width) {
        activeObject.set('left', coords.tl.x - (rightMost - width));
        modified = true;
    }
    if (topMost < 0) {
        activeObject.set('top', coords.tl.y + -topMost);
        modified = true;
    }
    if (bottomMost > height) {
        activeObject.set('top', coords.tl.y - (bottomMost - height));
        modified = true;
    }
    return modified;
};
exports.exportFabricCanvasToJson = function (fabricCanvas, rotate, originalWidth, originalHeight) {
    if (fabricCanvas) {
        fabricCanvas.getObjects().forEach(function (object) {
            object.shadow = undefined;
        });
        exports.rotateObjects({
            fabricCanvas: fabricCanvas,
            rotate: -rotate,
            originalWidth: originalWidth,
            originalHeight: originalHeight,
            renderAll: false,
        }); // we want to save objects in their unrotated state
        var json = fabricCanvas.toJSON(Object.keys(CreateStamp_1.styleOptions));
        json.dimensions = { width: originalWidth, height: originalHeight };
        json.rotate = rotate;
        // Rotate back the objects
        exports.rotateObjects({
            fabricCanvas: fabricCanvas,
            rotate: rotate,
            originalWidth: originalWidth,
            originalHeight: originalHeight,
            renderAll: false,
        });
        return json;
    }
    return undefined;
};
/**
 * Export into JSON with the current rotation angle
 * @param fabricCanvas
 * @param rotate
 * @param originalWidth
 * @param originalHeight
 */
exports.exportFabricCanvasToJsonNoRotate = function (fabricCanvas, rotate, originalWidth, originalHeight) {
    if (fabricCanvas) {
        fabricCanvas.getObjects().forEach(function (object) {
            object.shadow = undefined;
        });
        var json = fabricCanvas.toJSON(Object.keys(CreateStamp_1.styleOptions));
        json.dimensions = { width: originalWidth, height: originalHeight };
        json.rotate = rotate;
        json.fabricDataVersion = 1;
        return json;
    }
    return undefined;
};
exports.cloneFabricObject = function (fabricObject) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) {
                fabricObject.clone(function (clone) {
                    clone.setControlsVisibility(fabricObject._controlsVisibility);
                    resolve(clone);
                }, Object.keys(CreateStamp_1.styleOptions));
            })];
    });
}); };
//# sourceMappingURL=PdfEditorFabricUtil.js.map